// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
import { persist } from "zustand/middleware";
// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
// --- Logic --------------------------------------------------------------------------------------
type TyPageSizeStore = { pageSize: number; setPageSize: (size: number) => void };

/**
 * How many rows every list asks for — one setting, set once from any paginator and obeyed by all of
 * them. It is a person's preference about their own screen, not a property of a list, so it is kept
 * next to the language rather than in each screen's URL: a laptop shows forty comfortably where a
 * phone shows ten, and nobody wants to say so again on the next section.
 *
 * Clamped on the way in. The endpoints cap `limit` at 100 and ignore anything above it, so a bigger
 * number here would quietly mean a different page size than the one on screen.
 */
const usePageSize = create<TyPageSizeStore>()(
    persist(
        (set) => ({
            pageSize: constants.pageSize,
            setPageSize: (size) => set({ pageSize: Math.max(constants.minPageSize, Math.min(constants.maxPageSize, Math.round(size))) }),
        }),
        { name: "page-size" }
    )
);

export default usePageSize;
